var React = require('react');
import * as Yup from 'yup';
import { Box, Container, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import FormControl from '@mui/material/FormControl';
import MUIDataTable from 'mui-datatables';
import AppBar from '@mui/material/AppBar';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import TextField from "@mui/material/TextField";
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckIcon from '@mui/icons-material/Check';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';
import EditSummaryDialog from "../../AdminItems/EditDialogue/EditSummary";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 130,
            borderBottom: '1px solid #e0e0e0',
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            position: 'sticky',
            top: 56, // match toolbar height
            backgroundColor: '#fff',
            zIndex: 120,
          },
        },
      },
    },
  });

export default function ReportLPCheck() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [StartDate, setStartDate] = React.useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'));
    const [EndDate, setEndDate] = React.useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'));
    const [open, setOpen] = React.useState(false);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [permission, permissionSet] = React.useState([]);
    const [expand, setExpand] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true);
    const [overTime, setOverTime] = React.useState([]);
    const [fullScreen, setFullScreen] = React.useState(false);

    const initialValues = {
    };

    const validFormSchema = Yup.object({
    })

    const classes = pageStyles();
    const convertDates = (json) => {
		logger("json", json)
		json.forEach(eachObj => {
			eachObj.DayOf = moment.utc(eachObj.DayOf).format("MM/DD/YYYY");
			if (eachObj.LP_START) {
				eachObj.LP_START = moment.utc(eachObj.LP_START).format("MM/DD/YYYY");
			}
			
			if (eachObj.LP_END) {
				eachObj.LP_END = moment.utc(eachObj.LP_END).format("MM/DD/YYYY");
			}
			if (eachObj.Rate) {
				const byteArray = new Uint8Array(eachObj.Rate.data);
				const textDecoder = new TextDecoder();
				const res = textDecoder.decode(byteArray);
				const r = parseFloat(res).toFixed(2);
				eachObj.Rate = r;
			}
		});
		setDataSet(json);
		setIsLoading(false);
	};

   const getData = async () => {
		try {
			const apiUrl = `/api/Reports/LPCheck/${moment(StartDate).format('YYYY-MM-DD')}/${moment(EndDate).format('YYYY-MM-DD')}`;
			logger(apiUrl);

			const response = await fetch(apiUrl, { method: 'GET' });
			const json = await response.json();
			
			if (json.length > 0) {
				await GetOverTime(json[0].SOWID); // Await here is correct
			}

			logger('output', json);
			convertDates(json);

			

			//setRefresh(true);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};


	const GetOverTime = async (sow) => {
		try {
			const response = await fetch(`/api/SOW/OverTime/${sow}`, { method: 'GET' });
			const json = await response.json();

			setOverTime(json); // Ensure `overTime` is defined in the appropriate scope
		} catch (error) {
			console.error('Error fetching overtime data:', error);
		}
	};
	
    const handleGenerate = () => {
        setOpenLogs(true);
        getData()
        setIsLoading(true);
    };
    
     const calculateRate = (rate, flagType) => {
		if (overTime.length) {
			if (flagType === 'OT') {
				return (rate * overTime[0].OverTimeWeek).toFixed(2);
			} else if (flagType === 'WND') {
				return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
			} else if (flagType === 'HOL') {
				return (rate * overTime[0].OverTimeHoliday).toFixed(2);
			} else {
				return rate;
			}
		}
	};

    const columns = [
        {
            name: "Name",
            label: "Name",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "Task",
            label: "Task",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "DayOf",
            label: "Date",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        dataSet[dataIndex].DayOf
                    );
                }
            }
        },
        {
            name: "Hours",
            label: "Hours",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "Role",
            label: "Role",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "Project",
            label: "Project",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "PO",
            label: "PO",
            options: {
                sort: true,
                filter: true,
                filterOptions: {
                    renderValue: val => {
                        if (val === "" || val === null || val === undefined) {
                            return "Not Set";
                        }
                        return val;
                    }
                },
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    logger(`dataSet[dataIndex]`, dataSet[dataIndex])
                    if (dataSet[dataIndex].PO !== null)
                        return (
                            <>{dataSet[dataIndex].PO}</>
                        );
                    else
                        return (
                            <div>
                            <Tooltip title='Failing' className={classes.root}>
                                <ReportGmailerrorredIcon color='error' />
                                </Tooltip>
                                <EditSummaryDialog
                                    callRefresh={callRefresh}
                                    handleEditCallback={handleEditCallback}
                                    permission={permission}
                                    data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD')}} />
                            </div>
                        );
                }
            }          
        },
        {
            name: "LP_START",
            label: "L&P Start Date",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                       dataSet[dataIndex].LP_START
                    );
                }
            }
        },
        {
            name: "LP_END",
            label: "L&P End Date",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                       dataSet[dataIndex].LP_END
                    );
                }
            }
		},
		{
			name: "LP_IsActive",
			label: "L&P IsActive",
			options: {
				filter: false,
				sort: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					return (
						<div className={classes.root}>
							{(dataSet[dataIndex].LP_IsActive) ? <CheckIcon /> : <Tooltip title="In-Active L&P"><DoNotDisturbIcon sx={{ color: "red" }}/></Tooltip>}

						</div>
					);
				}
			}
		},
		{
				name: "FlagType",
				label: "FlagType",
				options: {
					sort: true,
					filter: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						if (dataSet[dataIndex].ProjectGroupName == "BCI") {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].FlagType) {

								return (
									<Tooltip title={dataSet[dataIndex].overTimeWarning ? "overTimeWarning" : ""}>
										<div style={dataSet[dataIndex].overTimeWarning ? { color: "red" } : {}}>

											{dataSet[dataIndex].FlagType}
										</div>
									</Tooltip>
								);
							}

						}
					}
				}
			},
		{
				name: "Rate",
				label: "RawRate",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`value`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>-----</>
							);
						}
						else {
							if (dataSet[dataIndex].Rate) {
								return (
									<>{overTime.length ? calculateRate(dataSet[dataIndex].Rate, dataSet[dataIndex].FlagType) : dataSet[dataIndex].Rate}</>
								);
							}
							else {
								return (
									<Tooltip title="L&P doesn't exists" className={classes.root}>
										<ReportGmailerrorredIcon color='error' />
									</Tooltip>
								);
							}
						}
					}

				}
			}, 
    ];
    const MakeToolbar = () => {
        //     <Tooltip title="Active Only" placement="right-end">
        return (
            <>
                {/*<Checkbox defaultChecked={expand} color="default" onClick={() => { setExpand(!expand), setRefresh(true); }} />*/}
            </>
        );
        logger("createTB" + MakeToolbar)
    }

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const baseOptions = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        responsive: 'standard',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
		},
        selectableRows: 'none',
        customToolbar: () => <MakeToolbar />,
          onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					logger("eachrow", eachRow)		
					eachRow[11] = calculateRate(eachRow[11], eachRow[10]);
				}
				return customBodyForExcelReport({data:data, headers:headers});
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'LPCheck.xlsx'})
			return false;
		}

    };
    
    var options = {};
	if (!fullScreen) {
		options = {
			...baseOptions,
			customToolbarTitle: CustomToolbarTitle,
			tableBodyHeight: "450px",
			tableBodyMaxHeight: "1000px",
			responsive: 'standard',
		}
	} else {
		options = {
			...baseOptions,
			responsive: 'standard',
			tableBodyHeight: "800px",
			tableBodyMaxHeight: "84vh",
			rowsPerPage: initialRowsPerPage,
			selectableRows: 'none',
		}
	}
    
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setExpand(true);
    };

    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };

    const handleCloseForLogs = () => {
        setDataSet([])
        setOpenLogs(false);
        setFullScreen(false);
    };

    const callRefresh = () => {
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("/api/Summary", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ApprovalAll": childData.approvalAll,
                "Week": childData.Week
            })
        })

        logger(childData)
        //   window.location.reload();
        setRefresh(true)
    };

    const handleStartDate = (Data) => {
		setStartDate(Data.target.value);
		logger(Data.target.value);
	}

	const handleEndDate = (Data) => {
		setEndDate(Data.target.value);
		logger(Data.target.value);
	}

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            fetch(`/api/User/Permission`)
                .then(res => res.json())
                .then(json => {
					permissionSet(json);
					
				})

            getData()
            setRefresh(false);
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };
    
    const handleMinimize = () => {
		setFullScreen(false);
	};
	
	const CustomToolbarTitle = () => (
		<Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
			Report All Time Entries
		</Typography>
	);

	const handleMaximize = () => {
		setFullScreen(true);
	};

    return (
        <div className={classes.root}>
            <Button className={classes.root} variant="contained" onClick={handleClickOpen}>
                Time Entry L&P Check
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="md" scroll="paper" overflow-y="hidden">
                    <DialogContent >
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validFormSchema}
                            onSubmit={(values, { resetForm }) => {
                                //onTrigger(values);
                                resetForm();
                            }}
                        >
                            {props => (
                                <Form>
                                    <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                            Time Entry L&P Check
                                        </Typography>
                                        <Button color="inherit" onClick={handleGenerate}>
                                            Generate
                                        </Button>
                                        </Toolbar>
                                    </AppBar>
                                    <DialogTitle>Time Entry L&P Check:</DialogTitle> 
                                    <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleStartDate}
                                                value={StartDate}
                                                label="Start Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='end'
                                                id="outlined-EndDate"
                                                type="date"
                                                onChange={handleEndDate}
                                                value={EndDate}
                                                label="End Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </DialogContent>
                    <Dialog
							open={openLogs}
							onClose={handleCloseForLogs}
							fullScreen={fullScreen}
							fullWidth
							maxWidth={fullScreen ? false : 'xl'}
							scroll="paper"
							PaperProps={{
								style: {
									height: fullScreen ? '100vh' : '70vh',
									margin: fullScreen ? 0 : '5vh auto',
									borderRadius: fullScreen ? 0 : 10,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}
							}}
						>
						<DialogContent
							sx={{
								p: 0,
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								overflow: 'hidden',
							}}>
							<Box
								sx={{
									flex: 1,
									overflowY: 'auto',
									overflowX: 'hidden',
									position: 'relative', // ✨ important for sticky to work
								}}>
								<ThemeProvider theme={getMuiTheme()}>
									<MUIDataTable 
										title={
											<Box>
												<Typography variant="h6" style={{ color: "white" }}>
													<IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
													<Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
														<IconButton
															color="inherit"
															onClick={fullScreen ? handleMinimize : handleMaximize}
														>
															{fullScreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}
														</IconButton>
													</Tooltip>
													Time Entry L&P Check
												</Typography>
											</Box>
										}
										data={isLoading ? [] : dataSet}
										columns={columns}
										options={muiLoaderOptions(options, isLoading)}
									/>
								</ThemeProvider>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 